"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddGrowCycleModal = AddGrowCycleModal;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var pagination_1 = require("../../../constants/pagination");
var facility_1 = require("../../../features/apis/facility");
var grow_cycle_1 = require("../../../features/apis/grow-cycle");
var paginated_content_1 = require("../../../utils/paginated-content");
var permission_error_1 = require("../../../utils/permission-error");
var use_debounce_1 = require("../../../utils/use-debounce");
var text_component_1 = require("../../ui/text-component");
var grow_cycle_form_fields_1 = require("./grow-cycle-form-fields");
var FACILITY_PAGE_SIZE = 30;
function shiftDate(value, days) {
    if (!value)
        return "";
    var date = new Date(value);
    date.setDate(date.getDate() + days);
    return date.toISOString().split("T")[0];
}
function AddGrowCycleModal(props) {
    var _this = this;
    var _a, _b, _c;
    var isOpen = props.isOpen, clientId = props.clientId, userId = props.userId, onClose = props.onClose, onCreated = props.onCreated;
    var _d = (0, react_2.useState)(""), name = _d[0], setName = _d[1];
    var _e = (0, react_2.useState)(""), startDate = _e[0], setStartDate = _e[1];
    var _f = (0, react_2.useState)(""), endDate = _f[0], setEndDate = _f[1];
    var _g = (0, react_2.useState)(""), facilityId = _g[0], setFacilityId = _g[1];
    var _h = (0, react_2.useState)(""), facilitySearch = _h[0], setFacilitySearch = _h[1];
    var _j = (0, react_2.useState)(pagination_1.DEFAULT_PAGE_NUMBER), facilityPage = _j[0], setFacilityPage = _j[1];
    var _k = (0, react_2.useState)([]), facilities = _k[0], setFacilities = _k[1];
    var _l = (0, react_2.useState)(""), error = _l[0], setError = _l[1];
    var debouncedFacilitySearch = (0, use_debounce_1.useDebouncedValue)(facilitySearch);
    var _m = (0, grow_cycle_1.useCreateGrowCycleMutation)(), createGrowCycle = _m[0], isCreating = _m[1].isLoading;
    var _o = (0, facility_1.useGetMyFacilitiesQuery)({
        clientId: clientId,
        userId: userId !== null && userId !== void 0 ? userId : "",
        size: FACILITY_PAGE_SIZE,
        pageNumber: facilityPage,
        search: debouncedFacilitySearch || undefined,
    }, {
        skip: !isOpen || !clientId || !userId,
    }), facilitiesData = _o.currentData, isLoadingFacilities = _o.isLoading, isFetchingFacilities = _o.isFetching, isFacilitiesError = _o.isError, facilitiesError = _o.error, refetchFacilities = _o.refetch;
    var canLoadMoreFacilities = (_c = (_b = (_a = facilitiesData === null || facilitiesData === void 0 ? void 0 : facilitiesData.content) === null || _a === void 0 ? void 0 : _a.pagination) === null || _b === void 0 ? void 0 : _b.hasNextPage) !== null && _c !== void 0 ? _c : false;
    (0, react_2.useEffect)(function () {
        setFacilityPage(pagination_1.DEFAULT_PAGE_NUMBER);
    }, [debouncedFacilitySearch, clientId]);
    (0, react_2.useEffect)(function () {
        var incomingFacilities = (0, paginated_content_1.getContentItems)(facilitiesData);
        if (facilityPage === pagination_1.DEFAULT_PAGE_NUMBER) {
            setFacilities(incomingFacilities);
            return;
        }
        setFacilities(function (currentFacilities) {
            var mergedById = new Map();
            currentFacilities.forEach(function (facility) {
                mergedById.set(facility.id, facility);
            });
            incomingFacilities.forEach(function (facility) {
                mergedById.set(facility.id, facility);
            });
            return Array.from(mergedById.values());
        });
    }, [facilitiesData, facilityPage]);
    var loadMoreFacilities = function () {
        if (!canLoadMoreFacilities || isFetchingFacilities) {
            return;
        }
        setFacilityPage(function (currentPage) { return currentPage + 1; });
    };
    (0, react_2.useEffect)(function () {
        if (!facilityId) {
            return;
        }
        var isFacilityStillAvailable = facilities.some(function (facility) { return facility.id === facilityId; });
        if (!isFacilityStillAvailable) {
            setFacilityId("");
        }
    }, [facilities, facilityId]);
    var isFormComplete = !!name.trim() && !!startDate && !!endDate && !!facilityId;
    var resetForm = function () {
        setName("");
        setStartDate("");
        setEndDate("");
        setFacilityId("");
        setFacilitySearch("");
        setFacilityPage(pagination_1.DEFAULT_PAGE_NUMBER);
        setFacilities([]);
        setError("");
    };
    var handleClose = function () {
        resetForm();
        onClose();
    };
    var handleCreate = function () { return __awaiter(_this, void 0, void 0, function () {
        var trimmedName, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setError("");
                    trimmedName = name.trim();
                    if (!trimmedName || !startDate || !endDate || !facilityId) {
                        setError("Please complete all fields.");
                        return [2 /*return*/];
                    }
                    if (!clientId) {
                        setError("Please select an active client before adding a grow cycle.");
                        return [2 /*return*/];
                    }
                    if (new Date(endDate).getTime() <= new Date(startDate).getTime()) {
                        setError("End Date must be after Start Date.");
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, createGrowCycle({
                            display_name: trimmedName,
                            start_date: startDate,
                            end_date: endDate,
                            facility_id: facilityId,
                            client_id: clientId,
                        }).unwrap()];
                case 2:
                    response = _b.sent();
                    if (!response.success) {
                        setError(response.message || "Unable to create grow cycle. Please try again.");
                        return [2 /*return*/];
                    }
                    onCreated === null || onCreated === void 0 ? void 0 : onCreated();
                    handleClose();
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    setError("Unable to create grow cycle. Please try again.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isOpen, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Backdrop, { children: (0, jsx_runtime_1.jsx)(react_1.Modal.Container, { children: (0, jsx_runtime_1.jsxs)(react_1.Modal.Dialog, { className: "sm:max-w-[560px]", children: [(0, jsx_runtime_1.jsx)(react_1.Modal.CloseTrigger, { onPress: handleClose }), (0, jsx_runtime_1.jsx)(react_1.Modal.Header, { children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1", children: [(0, jsx_runtime_1.jsx)("h3", { className: "text-lg font-bold text-dark-gray-1", children: "Add Grow Cycle" }), (0, jsx_runtime_1.jsx)("p", { className: "text-sm text-medium-gray", children: "Create a new grow cycle by filling out the details below." })] }) }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Body, { children: [(0, jsx_runtime_1.jsx)("div", { className: "grid grid-cols-1 sm:grid-cols-2 gap-3", children: (0, jsx_runtime_1.jsx)(grow_cycle_form_fields_1.GrowCycleFormFields, { name: name, onNameChange: setName, startDate: startDate, onStartDateChange: setStartDate, endDate: endDate, onEndDateChange: setEndDate, minEndDate: shiftDate(startDate, 1), maxStartDate: shiftDate(endDate, -1), facilityId: facilityId, onFacilityIdChange: setFacilityId, facilitySearch: facilitySearch, onFacilitySearchChange: setFacilitySearch, facilities: facilities, isLoadingFacilities: isLoadingFacilities, isLoadingMoreFacilities: isFetchingFacilities && !isLoadingFacilities, canLoadMoreFacilities: canLoadMoreFacilities, onLoadMoreFacilities: loadMoreFacilities }) }), isFacilitiesError && ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2 text-xs text-red-600", children: [(0, jsx_runtime_1.jsx)("span", { children: (0, permission_error_1.getLoadErrorMessage)(facilitiesError, "Unable to load facilities.") }), !(0, permission_error_1.isPermissionDeniedError)(facilitiesError) && ((0, jsx_runtime_1.jsx)("button", { type: "button", onClick: function () { return refetchFacilities(); }, className: "underline cursor-pointer", children: "Retry" }))] })), error && ((0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: error }) }))] }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Footer, { children: [(0, jsx_runtime_1.jsx)(react_1.Button, { variant: "secondary", onPress: handleClose, isDisabled: isCreating, className: "rounded-md", children: "Cancel" }), (0, jsx_runtime_1.jsx)(react_1.Button, { onPress: handleCreate, isPending: isCreating, isDisabled: !clientId || !isFormComplete || isLoadingFacilities || facilities.length === 0, className: "rounded-md bg-primary-navy text-white hover:bg-primary-navy-light", children: "Create Grow Cycle" })] })] }) }) }) }));
}
